import { Component, OnInit } from '@angular/core';
import { SectionService } from "../../../services/help/section.service";
import { Section } from '@app/models/help/section.model';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  public oneAtATime = true;
  public sections: Section[];

  constructor(private sectionService: SectionService) { }

  public ngOnInit() {
    this.sectionService.getListWithQuestions().subscribe(result => {
      this.sections = <Section[]>(result);
    });
  }
}
